import { useTranslation } from 'react-i18next'
import { useTheme, type Theme } from '@/shared/lib'
import { Icon, type IconName } from '@/shared/ui/Icon'
import type { MenuGroupItem, MenuLeafItem } from '@/shared/ui/Menu'

const THEMES: Theme[] = ['light', 'dark', 'system']

/** Глиф повторяет выбор, а не итоговую тему: «Системная» остаётся экраном, а не солнцем. */
export const THEME_ICON: Record<Theme, IconName> = {
  light: 'sun',
  dark: 'moon',
  system: 'monitor',
}

/**
 * Выбор темы группой меню. Общий у кнопки в шапке и у меню аккаунта: на узком экране кнопке
 * в шапке нет места, и выбор переезжает в меню аккаунта теми же пунктами.
 */
export function useThemeMenuGroup(): MenuGroupItem {
  const { t } = useTranslation()
  const { theme, setTheme } = useTheme()

  return {
    kind: 'group',
    id: 'theme',
    label: t('theme.label'),
    items: THEMES.map<MenuLeafItem>((value) => ({
      kind: 'radio',
      id: `theme-${value}`,
      label: t(`theme.${value}`),
      icon: <Icon name={THEME_ICON[value]} size="sm" />,
      checked: theme === value,
      onSelect: () => setTheme(value),
    })),
  }
}
